import { useState, useEffect } from "react";

const useUserProfile = (userId) => {
  const [profile, setProfile] = useState(null);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  useEffect(() => {
    if (!userId) return; // exit if no id

    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem("access_token"); 
        const response = await fetch(
          `${BASE_URL}/user/profile/user-profile/${userId}/`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // pass token
              "x-api-key": process.env.REACT_APP_X_API_KEY,
            },
          }
        );

        if (!response.ok) throw new Error("Failed to fetch profile");
        const data = await response.json();
        setProfile(data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchProfile();
  }, [userId]);

  return profile;
};

export default useUserProfile;
